import { Injectable } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { StorageService } from './storage.service';
import { ActionType, Country, PageReadyData } from '../models/global-tracking.model';
import { LoginStatus, pageData, userData } from '../models/global-tracking.model';
import { ERROR_PAGE_DATA } from '../models/error-handle-tracking.model';
import { GlobalTrackingService } from './global-tracking.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ErrorTrackingService {

  constructor(
    private globalTrackingService: GlobalTrackingService,
    private storageService: StorageService,
    private authService: AuthService,
    private router: Router
  ) { }

  trackErrorPageReady(): void {
    let loginStatus: string
    this.authService.isUserLoggedIn().subscribe((data) => {
      loginStatus = data ? LoginStatus.LOGGED_IN : LoginStatus.LOGGED_OUT;

      const pageData: pageData = {
        path: this.router.url,
        title: ERROR_PAGE_DATA.TITLE,
        country: Country.COUNTRY,
        language: this.storageService.selectedLanguage || '',
        template: ERROR_PAGE_DATA.TEMPLATE,
      };

      const user: userData = {
        loginStatus: loginStatus,
        role: this.storageService?.userRoles || '',
        company: this.storageService?.defaultLegalEntity?.name || '',
        companyId:
          this.storageService?.defaultLegalEntity?.uid || '',
      };

      const pageLoadData: PageReadyData = {
        page: pageData,
        user: user,
      };
      this.globalTrackingService.sendPageReadyData(ActionType.PAGE_READY, pageLoadData)
    });
  }
}